import { getCurrentStep } from '../helpers';
/**
 * Checks if current step is the last one
 * @returns {Bool} - true if current step is last, false if not
 */
export function isCurrentStepLast() {
	return (window.modForm.opts.steps.length - Array.from(window.modForm.opts.steps).indexOf(getCurrentStep())) === 1;
}
